import { P2GAlert, P2GBox, P2GText } from '@parcel2go/core-ui';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import OrderBookingStatusObserver from '../OrderBookingStatusObserver';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  group: ProviderGroup;
  markAsDispatched: () => void;
  onAllTrackingNumbersGenerated: () => void;
}

const ProviderGroupSummaryStaged: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox>
      <P2GText component="p" colour="primary">
        <Trans t={t} i18nKey="PROVIDER_SUMMARY_BOOKING_LINK_CREATED" defaults="<strong>Booking Link Created</strong>" />
      </P2GText>
      <P2GBox mb={2}>
        <P2GText variant="body2">
          <Trans
            t={t}
            i18nKey="PROVIDER_SUMMARY_BOOKING_LINK_CREATED_DESCRIPTION"
            defaults="Click 'Continue To Payment' to confirm and pay for your order."
          />
        </P2GText>
      </P2GBox>
      <P2GAlert palette="primary">
        <P2GText variant="body2">
          <Trans
            t={t}
            i18nKey="PROVIDER_SUMMARY_BOOKING_LINK_CREATED_INFO"
            defaults="Your labels will be shown here once payment has been taken."
          />
        </P2GText>
      </P2GAlert>
      <OrderBookingStatusObserver
        wrapper={(x) => <P2GBox>{x}</P2GBox>}
        hasPaid={false}
        items={props.group.Items}
        onAllTrackingNumbersGenerated={props.onAllTrackingNumbersGenerated}
      />
    </P2GBox>
  );
};

export default ProviderGroupSummaryStaged;
